import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerPlanSummaryDTO } from 'src/app/models/CustomerPlanSummaryDTO.model';
import { AlertService } from 'src/app/shared/services/alert.service';

import { DeviceFormComponent } from '../../devices/device-form/device-form.component';
import { CreateTicketFormComponent } from '../../tickets/create-ticket-form/create-ticket-form.component';
import { ModalAlertControlComponent } from '../../../shared/controls/modal-alert-control/modal-alert-control.component';
declare var bootstrap: any;

@Component({
    selector: 'app-customer-device-activation',
    templateUrl: './customer-device-activation.component.html',
    styleUrl: './customer-device-activation.component.css',
    imports: [DeviceFormComponent, CreateTicketFormComponent, ModalAlertControlComponent]
})
export class CustomerDeviceActivationComponent {

  iccid: string = '';
  errorMessage: string = '';

  listPlans: CustomerPlanSummaryDTO[] = [];

  goBackRoute: string = '';

  constructor(private alertService: AlertService, private route: ActivatedRoute,
    private router: Router) {

  }

  ngOnInit() {

    
    this.route.params.subscribe(params => {

      this.iccid = (params['id']); // Access the 'id' parameter from the URL

    });

    this.listPlans = history.state.listPlans || [];
    this.goBackRoute = history.state.goBackRoute || '';
  }

  handleCreateUpdateResponse(event: string) {

    

    if (event) {
      this.errorMessage = event;

      bootstrap.Modal.getOrCreateInstance(document.getElementById('createTicketAlert')).show();
    }
  }

  handleTicketResponse(event: string) {


    if (event) {
      this.alertService.error(event);
      return;
    }


    bootstrap.Modal.getOrCreateInstance(document.getElementById('customerCreateTicketModal')).hide();

    this.alertService.success('Ticket created successfully');

    window.history.back();


  }

  onOkButtonClick(isOkButtonClick: boolean) {


    if (event) {
      bootstrap.Modal.getOrCreateInstance(document.getElementById('createTicketAlert')).hide();

      bootstrap.Modal.getOrCreateInstance(document.getElementById('customerCreateTicketModal')).show();
      return
    }
    window.history.back();
  }

  goBack() {
    window.history.back();
  }


}
